import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import type {ILogger} from "ads-client-base/modules/logger/domain/iLogger";
import {PrebidJsBaseBiddersLoader} from "../../prebidJsBaseBiddersLoader";

export class MotoresPrebidJsBiddersLoader extends PrebidJsBaseBiddersLoader {

    public constructor(logger: ILogger) {
        super(logger);
    }

    protected override async registerBidder(bidder: Bidders, config: HeaderBiddingConfig) {
        switch (bidder) {
            case Bidders.RICHAUDIENCE:
                const { RichAudienceBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/richAudienceBidder');
                this.bidders[bidder] = new RichAudienceBidder(config);
                break;
            case Bidders.APPNEXUS:
                const { AppNexusBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/appNexusBidder');
                this.bidders[bidder] = new AppNexusBidder(config);
                break;
            case Bidders.TEADS:
                const { TeadsBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/teadsBidder');
                this.bidders[bidder] = new TeadsBidder(config);
                break;
            case Bidders.OGURY:
                const { OguryBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/oguryBidder');
                this.bidders[bidder] = new OguryBidder(config);
                break;
            case Bidders.INDEXEXCHANGE:
                const { IndexExchangeBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/indexEchangeBidder');
                this.bidders[bidder] = new IndexExchangeBidder(config);
                break;
            case Bidders.MEDIANET:
                const { MediaNetBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/mediaNetBidder');
                this.bidders[bidder] = new MediaNetBidder(config);
                break;
            case Bidders.RUBICON:
                const { RubiconBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/rubiconBidder');
                this.bidders[bidder] = new RubiconBidder(config);
                break;
            case Bidders.SEEDTAG:
                const { SeedtagBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/seedtagBidder');
                this.bidders[bidder] = new SeedtagBidder(config);
                break;
            case Bidders.AKCELO:
                const { AkceloBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/akceloBidder');
                this.bidders[bidder] = new AkceloBidder(config);
                break;
            case Bidders.MONETIXADS:
                const { MonetixAdsBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/monetixAdsBidder');
                this.bidders[bidder] = new MonetixAdsBidder(config);
                break;
            case Bidders.SPARTEO:
                const { SparteoBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/sparteoBidder');
                this.bidders[bidder] = new SparteoBidder(config);
                break;
            case Bidders.TAPPX:
                const { TappxBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/tappxBidder');
                this.bidders[bidder] = new TappxBidder(config);
                break;
            case Bidders.OPTIDIGITAL:
                const { OptidigitalBidder } = await import('header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/adapters/optidigitalBidder');
                this.bidders[bidder] = new OptidigitalBidder(config);
                break;
            default:
                throw new Error(`Bidder ${bidder} not supported`);
        }
    }
}
